import { Injectable } from "@angular/core";
import {Color, Chart } from "chart.js";
import { cloneDeep } from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { distance } from "ol/coordinate";
import { HTMLPath } from "../footer/performance-report/performance-report.component";
import { PerformanceAnalysisDTO } from "../models/performanceAnalysisDTO";
import { PairCoverageInfo, PerformanceReportDTO, WayPointInfoDTO } from "../models/performanceReportDTO";
import { ProcedureCoordinatePointModel } from "../models/procedure-coordinate-point";
import { GenerateReportComponent } from "../popup/generate-report/generate-report.component";
import { CalculationsService } from "./calculations.service";
import { ConfigurationService } from "./configuration.service";
import { PointsService } from "./points.service";
import { ToolsControlService } from "./tools-control.service";
import { UtilsService } from "./utils.service";
import { VicentyToolControlService } from './vicenty-tool-control.service';
import { Geometry } from "ol/geom";
import { Feature } from "ol";


@Injectable({
  providedIn: 'root'
})

export class PerformanceReportService{
  active : boolean;
  fullScreenMode : boolean = false;

  report: PerformanceReportDTO;
  chart: Chart;
  paths: Array<HTMLPath> = [];


  chartPlugins = [{
    id: 'draw_waypoints_performance_report',
    afterDraw: chart => {
      let ctx = chart.ctx;
      ctx.save();
      let dataSet = [];


      const waypointsDataset = chart.data.datasets.find(dataset => dataset.label == "wayPoints");
      //ctx.textAlign = 'center';
      ctx.font = '14px Arial';
      ctx.fillStyle = 'grey';
      ctx.textAlign = 'left';
      let yPosition = chart.scales.yAxes.top  + chart.scales.yAxes.height / 2.2;
      if (chart.config.type  != 'bar'){
        yPosition = chart.scales.yAxes.getPixelForValue(chart.scales.yAxes.max) + chart.scales.yAxes.paddingTop;
      }
      waypointsDataset.data.forEach(waypoint => {
        ctx.fillText((waypoint as any).wayPointId, chart.scales.xAxes.getPixelForValue((waypoint as any).x),yPosition);
      });
      ctx.restore();}

  },];
  constructor(
    private toolsService : ToolsControlService,
    private calculationsService: CalculationsService,
    public utilsService : UtilsService,
    public pointsService: PointsService,
    private popupService: BsModalService,
    private vicentyTool: VicentyToolControlService,
    private configurationService: ConfigurationService
   ){}

  openWindow(report : PerformanceReportDTO):void {
    this.report = report;
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.displayGraphicInfo();

  }
  private continue( currIndex: Array<number>,graphicInfo: Array<PairCoverageInfo> ):boolean{
    for(let i in currIndex){
      if(currIndex[i] < this.report.graphicInfo[i].values.length){
        return true;
      }
    }
    return false;
  }



  private getChartDataset(coverageValue:number,color:string,distances: number[]){
    let result  = [];
    let currIndex = new Array(this.report.graphicInfo.length).fill(0);
    while(this.continue(currIndex,this.report.graphicInfo) ){
      let sections: Array<Array<Number>> = Array<Array<Number>>();
      for(let i in this.report.graphicInfo){
        let coverageValues = this.report.graphicInfo[i].values;
        let insideSection: boolean =  false;
        let foundSection: boolean = false;
        //this.configurationService.currentConfiguration.display.horizontalUnits
        let sectionArray: Array<Number> = new Array<Number>();
        for(let j = currIndex[i]; j < coverageValues.length; j++){
            if(!insideSection){
              if(coverageValues[j] == coverageValue){
                insideSection = true;
                foundSection =true;
                sectionArray.push(distances[j]);
                if(j == coverageValues.length -1){
                  sectionArray.push(distances[j]);
                }
              }
            }
            else{
              if(coverageValues[j] != coverageValue){
                sectionArray.push(distances[j]);
                sections.push(sectionArray);
                currIndex[i] = j;
                insideSection = false;
                break;
              }
            }
        }
        if(insideSection){
          sectionArray.push(distances[coverageValues.length-1]);
          sections.push(sectionArray);
          currIndex[i] = coverageValues.length;
        }
        else if(!foundSection){
          sections.push([0,0])
          currIndex[i] = coverageValues.length;
        }
      }
      result.push({ label : coverageValue == 1? "Partial Coverage" : "Total Coverage",
                  data : sections,
                   borderWidth: 1,
                   backgroundColor: color,
                   barPercentage: 0.2
                  });
    }
    return result;
  }
  public getChartLabels(){
    let labels:Array<String> = new Array<String>();
    for(let i in this.report.graphicInfo){
      labels.push(this.report.graphicInfo[i].name);
    }
    return labels;
  }
  getLegsDistance(legs: any[]): number[]{
    let distance: number = 0;
		var rootPointsDistance: number[] = [];
		rootPointsDistance.push(distance);
		for (let i = 0; i < legs.length; i++) {
			let leg = legs[i];
			distance += this.calculateDistance(leg);
			rootPointsDistance.push(distance);
		}
    return rootPointsDistance;
  }

  private calculatePoint(i: number, t:number , radius: number, leg: any): any {
		let calculatedPoint: number[] = VicentyToolControlService.calculateDestinationPoint(leg.fixPoint.startPoint.altitude,
				leg.fixPoint.startPoint.longitude, t, radius);
		let newPoint: any = new Object;
		newPoint.altitude = leg.startPoint.altitude;
		let point: any = new Object;
		point.latitude = calculatedPoint[0];
		point.longitude = calculatedPoint[1];
		point.coordpointid = leg.id + "CP" + i;
		newPoint.coordPoint = point;
		newPoint.isstraightleg = false;
		leg.curvePoints.push(newPoint);
		i++;
		return newPoint;
	}
  private calculateCurvePoints(leg: any) : any {

		var toReturn = [];

		leg.curvePoints = [];
		var i: number = 0;

		var radius: number = VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
      leg.startPoint.coordPoint.longitude, leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude);
		var startAzimuth: number = VicentyToolControlService.calculateAzimuth(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude, leg.startPoint.coordPoint.latitude,
      leg.startPoint.coordPoint.longitude);
		var endAzimuth: number = VicentyToolControlService.calculateAzimuth(leg.fixPoint.coordPoint.latitude,
      leg.fixPoint.coordPoint.longitude,leg.endPoint.coordPoint.latitude,
      leg.endPoint.coordPoint.longitude);

		var angle: number = startAzimuth - endAzimuth;
		if (angle > 0.0) {
			if (angle > 180.0) {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t + leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			} else {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t - leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			}
		} else {
			angle = Math.abs(angle);
			if (angle > 180.0) {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t - leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			} else {
				for (let t: number = startAzimuth; Math.round(t * 10.0) / 10.0 != Math.round(endAzimuth * 10.0)
						/ 10.0; t = ((t + leg.curveSmoothness) % 360.0 + 360.0) % 360.0) {
					toReturn.push(this.calculatePoint(i, t, radius, leg));
				}
			}
		}
		return toReturn;
	}
  private calculateDistance(leg: any) : number {
    var distance: number = 0.0;
    if (leg.isstraightleg) {
      distance += VicentyToolControlService.calculateDistance(leg.startPoint.coordPoint.latitude,
        leg.startPoint.coordPoint.longitude, leg.endPoint.coordPoint.latitude,
        leg.endPoint.coordPoint.longitude);
    } else {

      if (leg.curvePoints == null || leg.curvePoints.length == 0) {
        leg.curvePoints = this.calculateCurvePoints(leg);
      }

      var previousLat: number = leg.startPoint.coordPoint.latitude;
      var previousLong: number = leg.startPoint.coordPoint.longitude;

      for (let curvePoint of leg.curvePoints) {
        distance += VicentyToolControlService.calculateDistance(previousLat, previousLong, curvePoint.latitude,
            curvePoint.longitude);
        previousLat = curvePoint.latitude;
        previousLong = curvePoint.longitude;
      }
    }

    return distance;
  }
  public getXAxisMax(coverageDatasets){
    const INT_MIN = -2147483648;
    let max = INT_MIN;
    for(let dataset of coverageDatasets){
      for(let sectionArray of dataset.data){
        if(max < sectionArray[1]){
          max = sectionArray[1];
        }
      }
    }
    return max;
  }
  getWayPointDataSet(points: ProcedureCoordinatePointModel[],distances:number[], maxLabel:String, minLabel:String){
    let dataSet = [];
    for(let i = 0; i < distances.length; i++){
      dataSet.push(...[{x:distances[i], y:maxLabel ,wayPointId: points[i].coordPoint.coordpointid },
          {x:distances[i] , y:minLabel , wayPointId: points[i].coordPoint.coordpointid},
          {x:NaN,y:NaN}
        ])
    }
    return {label: 'wayPoints',
      type: 'line',
      data:dataSet,
      fill:false,
      borderColor:'rgba(0, 0, 0)',
      borderWidth: 1,
      tension: 0.1,
      pointBorderWidth:0,
      borderDash:[5,10],
      pointRadius:0,
      backgroundColor: 'rgba(0, 0, 0)',
    }
  }
  public displayGraphicInfo(){
    let distances = [];
    let wayPointsDistance = [];
    let labelAdjustmentParam:number; //adjust the position of waypoint ids on the char
    let endMargin:number
    if(this.configurationService.currentConfiguration.display.horizontalUnits == 'NM'){
      distances = this.report.graphicInfo[0].distances.map((distance) => this.utilsService.metersToNm(distance));
      wayPointsDistance = this.getLegsDistance(this.report.procedureModel.procedureLegs).map((legDistance) =>  this.utilsService.metersToNm(legDistance));
      labelAdjustmentParam = 2.3;
      endMargin = 10;
    }
    else{
      wayPointsDistance = this.getLegsDistance(this.report.procedureModel.procedureLegs);
      distances = this.report.graphicInfo[0].distances;
      labelAdjustmentParam = this.utilsService.nmToMeters(2.3);
      endMargin = this.utilsService.nmToMeters(10);
    }
    let datasetsPartialCoverage = this.getChartDataset(1,'rgb(255,0,0)',distances);
    let datasetsTotalCoverage = this.getChartDataset(2,'rgb(0,255,0)',distances);
    let coverageDatasets = [];
    coverageDatasets.push(...datasetsPartialCoverage);
    coverageDatasets.push(...datasetsTotalCoverage);



    let totalCoverageIndex = datasetsPartialCoverage.length;
    let labels = this.getChartLabels();


  coverageDatasets.push(this.getWayPointDataSet(this.report.procedureModel.procedureCoordinatePoints,wayPointsDistance,labels[labels.length-1],labels[0]))



    if(this.chart != null){
      this.chart.destroy()
    }
    this.chart = new Chart(document.getElementById("coverageCanvas") as HTMLCanvasElement, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: coverageDatasets
      },
      plugins: this.chartPlugins,
      options: {
        indexAxis: 'y',
        responsive: true,
        scales: {
          yAxes: {
            beginAtZero: true,
            stacked: true,
          },
          xAxes: {
            stacked: false,
            max: this.getXAxisMax(coverageDatasets) + endMargin
          }
        },
        plugins: {
          legend:{
              labels:{
                filter: (legendItem, chartData) => (legendItem.datasetIndex == 0 || legendItem.datasetIndex == totalCoverageIndex)
              },
              onClick: function(e, legendItem) {
                let color = legendItem.text == "Partial Coverage" ? 'rgb(255,0,0)': 'rgb(0,255,0)';
                for( let i = 0; i < this.chart.data.datasets.length; i++){
                  if(this.chart.data.datasets[i].backgroundColor != color ){
                    continue;
                  }
                  if(this.chart.getDatasetMeta(i).hidden == null){
                    this.chart.getDatasetMeta(i).hidden = true;
                  }
                  else{
                    this.chart.getDatasetMeta(i).hidden = !this.chart.getDatasetMeta(i).hidden
                  }
                }
                this.chart.update()
              }
          },
          title: {
            display: true,
            text: 'RNAV Pair Coverage'
          },
        },
      },
    });
    console.log();

  }
  public closeWindow():void{
    this.active =false;
    this.paths = [];
    if(this.chart != null){
      this.chart.destroy()
    }
  }

  public getPerformanceReport(performanceAnalysisDTO :PerformanceAnalysisDTO,data:any):PerformanceReportDTO {
    let report : PerformanceReportDTO = new PerformanceReportDTO();
    PerformanceReportDTO.setNavaidsTable(report,performanceAnalysisDTO.navaids,this.pointsService,this.configurationService.currentConfiguration.display.coordinateFormat);
    PerformanceReportDTO.setProcedureTable(report, performanceAnalysisDTO.procedureModel.procedureLegs, this.configurationService.currentConfiguration.display.coordinateFormat );

    report.procedureModel = performanceAnalysisDTO.procedureModel;

    performanceAnalysisDTO.procedure.waypoints = performanceAnalysisDTO.procedure.waypoints.filter( waypoint => !waypoint.fixpoint);
    PerformanceReportDTO.map(report,data,this.configurationService.currentConfiguration.display.horizontalUnits);
    return report;
  }
  public generateReport(){
    PerformanceReportDTO.setRunplanningTable(this.report,this.paths);

    this.report.image = this.chart.toBase64Image();
    const bsModalRef : BsModalRef = this.popupService.show(GenerateReportComponent);
    bsModalRef.content.report = cloneDeep(this.report);
  }
}
